export function useInternalJobreferrals() {
  const isInternalJobReferrals = computed(() => {
    return useRoute().path.includes('internal-job-referrals')
  })

  return {
    isInternalJobReferrals
  }
}
